import { render } from "./header.vue?vue&type=template&id=34aa4a28"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=34aa4a28&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__